"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRaceParticipantsList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all participants from a single race by given ID (if it exists).
 *
 * Race is identified by its stringified `ObjectID`.
 *
 * ### Filter options
 *
 * - `dnf` - filter participants by their status of finishing the race.
 *
 * ### Sort options
 *
 * - `startDate` - sort participants by their start date
 * - `endDate` - sort participants by their end date
 * - `score` - sort participants by their score
 *
 * ## Usage
 * ```ts
 * const raceId: string = "5f5e555d5a578b6";
 * const participantsAll: RacePlayer[] = await sdk.getRaceParticipantsList({ raceId });
 * const participantsDnf: RacePlayer[] = await sdk.getRaceParticipantsList({ raceId, filter: { dnf: true }});
 * const participantsLeaderboards: RacePlayer[] =
 * 	await sdk.getRaceParticipantsList({ raceId, sort: { score: 'desc' }});
 * ```
 *
 * @param params.raceId - ID of the race to get its participants from.
 * @param params.filter - Filter to apply to returned race participants list.
 * @param params.sort - Fields to sort race participants list by.
 * @param params.limit - How many race participants will get returned.
 */
const getRaceParticipantsList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { raceId, filter, sort, limit } = params;
    const url = `${BASE_URL}/races/race/${raceId}/participants/list`;
    const racePlayerResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = racePlayerResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getRaceParticipantsList = getRaceParticipantsList;
